import store from '@/store';
export default {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  column: [
    {
      label: "主键id",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "进件编号",
      prop: "businessCode",
      type: "input",
      search: true,
      searchOrder: 994,
    },
    {
      label: "所属代理商",
      prop: "businessDeptName",
      type: "input",
    },
    {
      label: "产品类型",
      prop: "rentType",
      type: "select",
      dicData: store.getters.porductTypes
    },
    {
      label: "产品类型",
      prop: "rentTypeList",
      type: "select",
      search: true,
      searchMultiple: true,
      searchOrder: 999,
      hide: true,
      showColumn: false,
      dicData: store.getters.porductTypes
    },
    {
      label: "租赁人",
      prop: "name",
      type: "input",
      search: true,
      searchOrder: 998,
    },
    {
      label: "手机号",
      prop: "phoneNumber",
      type: "input",
    },
    {
      label: "车牌号",
      prop: "carFirstNumber",
      type: "input",
      search: true,
      searchOrder: 997,
    },
    {
      label: "保险类型",
      prop: "insuranceType",
      type: "select",
      search: true,
      hide: true,
      showColumn: false,
      searchOrder: 996,
      dicData: [
        {
          label: "交强险",
          value: "1",
        },
        {
          label: "商业险",
          value: "2",
        },
      ],
    },
    {
      label: "保险到期",
      prop: "insuranceExpireDate",
      type: "daterange",
      valueFormat: "yyyy-MM-dd",
      search: true,
      searchOrder: 995,
      searchRange: true,
      hide: true,
      showColumn: false,
    },
    {
      label: "交强险到期",
      prop: "carInsurance1EndDate",
      type: "datetime",
    },
    {
      label: "商业险到期",
      prop: "carInsurance2EndDate",
      type: "datetime",
    },
    {
      label: "放款时间",
      prop: "lendingTime",
      type: "date",
    },
    {
      label: "所属代理商",
      prop: "businessDeptIdList",
      type: "select",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },
  ],
};
